// Standard Gingham Tree booth dimensions. Keep in sync with src/utils/boothInfo.js.

export const BOOTH_SIZE_SHORT = '12x12';
export const BOOTH_SIZE_LABEL = '12×12';
export const BOOTH_SIZE_DESCRIPTION =
  'Each booth space is 12 feet by 12 feet (12×12).';
